<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Domain Configuration</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_STATIC_PAGE_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add domain</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="domain">Domain</th>
          <th>Slug</th>
          <th tableSorterHeader="product">Product</th>
          <th tableSorterHeader="lang">Language</th>
          <th tableSorterHeader="status">Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
          @for (availableDomain of availableDomains; track availableDomain.id) {
            <tr>
              <td>{{ availableDomain.id }}</td>
              <td>{{ availableDomain.domain }}</td>
              <td><span class="badge bg-primary">{{ availableDomain.getSlug() }}</span></td>
              <td>
                @if (availableDomain.product) {
                  {{ availableDomain.product }}
                } @else {
                  All
                }
              </td>
              <td>
                @if (availableDomain.lang) {
                  <img [ngSrc]="langService.getFlag(availableDomain.lang)" [alt]="availableDomain.lang"
                       class="country-flag"
                       width="24" height="24">
                } @else {
                  All
                }
              </td>
              <td>
                @if (availableDomain.status === 'succeeded') {
                  <i class="bi bi-circle-fill text-success"></i>
                } @else if (availableDomain.status === 'failed') {
                  <i class="bi bi-circle-fill text-danger"></i>
                } @else {
                  <i class="bi bi-circle-fill text-dark"></i>
                }
              </td>
              <td>
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[availableDomain.id]"><i
                  class="bi bi-pencil me-1"></i>Edit
                </a>
                <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(availableDomain)"><i
                  class="bi bi-trash"></i></button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
